import {
  listPageStyles,
  listsTableCellStyles
} from "../../Modelportfolios/List/styles";

const styles = (theme, props) => ({
  header: {
    fontFamily: 'Roboto-Bold',
    fontSize: 34,
    color: '#202A38',
    margin: 0
  },
  ...listPageStyles,

  tableCell: {
    '&:first-child': {
      width: 300
    },

    '&:nth-child(2)': {
      width: 150
    },

    '&:last-child': {
      width: (props) => props.viewOnly ? 100 : 150,
    },

    ...listsTableCellStyles
  },
  tableRow: {
    transition: 'all',
    transitionDuration: 250,
    '&:hover': {
      backgroundColor: '#EEF0F2'
    }
  },

  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',

    '& button >span > span': {
      fontSize: 14
    }
  }
});

export default styles;